import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import LoginPage from '@/components/LoginPage'
import LogoutPage from '@/components/LogoutPage'
import PageNotFound from '@/components/PageNotFound'
import ServerProblem from '@/components/ServerProblem'
import BusinessTripImpositionRouter from './BusinessTripImpositionRouter'
import BusinessTripRequestRouter from './BusinessTripRequestRouter'
import BusinessTripUnreleaseFunds from './BusinessTripUnreleaseFundsRouter'
import BusinessTripResendEmail from './BusinessTripResendEmail'
import BusinessTripRealizationRouter from './BusinessTripRealizationRouter'
import BusinessTripWorklistRouter from './BusinessTripWorklistRouter'
import BusinessTripSummaryRouter from './BusinessTripSummaryRouter'
import Dashboard from '@/components/Dashboard'

import store from '@/store'
import Notification from '@/helpers/notification'
import Dialogs from '@/helpers/dialogs'
import Backend from '@/helpers/backend'
import ApiClient from '@/api/Client'

import Vuetify from 'vuetify'

Vue.use(Router)
Vue.use(Vuetify)
Vue.use(Notification)
Vue.use(Dialogs)

const SWAGGER_API_ENDPOINT = '/v2/api-docs'
const TOKEN_LOCAL_STORAGE = 'token'

function registerBackend (vue, options, router) {
  return new Promise((resolve, reject) => {
    ApiClient.build(options, router)
      .then(res => {
        vue.use(Backend, res)
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/',
          name: 'Home',
          component: Dashboard
        },
        ...BusinessTripImpositionRouter,
        ...BusinessTripRequestRouter,
        ...BusinessTripUnreleaseFunds,
        ...BusinessTripResendEmail,
        ...BusinessTripRealizationRouter,
        ...BusinessTripWorklistRouter,
        ...BusinessTripSummaryRouter
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      props: true
    },
    {
      path: '/logout',
      name: 'Logout',
      component: LogoutPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/server_problem',
      name: 'ServerProblem',
      component: ServerProblem,
      props: true
    },
    { path: '*', component: PageNotFound }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'ServerProblem') {
    const self = this
    const callNext = () => {
      if (typeof Vue.prototype.$backend === 'undefined') {
        registerBackend(Vue, {url: SWAGGER_API_ENDPOINT, tokenLocalStorage: TOKEN_LOCAL_STORAGE},
          {router: self.a, loginRoute: 'Login'})
          .then(res => {
            next()
          })
          .catch(err => {
            // if unauthorized, assumed that the token is expired, clear it
            if (err.status === 401) {
              localStorage.clear()
              next({path: '/login', query: {redirect: to.fullPath}})
            } else {
              next(err)
            }
          })
      } else {
        next()
      }
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!store.getters.isLoggedIn) {
        next({path: '/login', query: {redirect: to.fullPath}})
      } else {
        callNext()
      }
    } else {
      callNext()
    }
  } else {
    next()
  }
})

router.onError(err => {
  const description = typeof err.message !== 'undefined' ? err.message : 'General Error'
  router.replace({name: 'ServerProblem', params: {description: description}})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js